export const COOKIEBANNER = "cookiebanner";
export const COOKIEBANNER_EXPIRES = 365; // days
